<template>
  <instForm  class="isntMainWrap"></instForm>
</template>

<script>
// import { mapState} from 'vuex';
import {mapState} from "vuex";
// import testData from "@/store/Form/testData";
import "@/assets/css/fontRoboto.css";
import "@/assets/css/variable.css";
import "@/assets/css/instDesignLnd25.css";
import "@/assets/css/instInputs.css";
export default {
  name: "registration-index",
  data() {
    return {

    }
  },
  methods: {
    parseParam(){
      try {
        // this.GUID = (this.$route.query?.state !== undefined)
        //   ? this.$route.query?.state
        //   : this.$route.query?.r !== undefined
        //     ? this.$route.query?.r
        //     : localStorage.getItem('GUIDeasyConf') !== null
        //       ? localStorage.getItem('GUIDeasyConf')
        //       : null;
        this.GUID = this.$route.query?.r !== undefined
          ? this.$route.query?.r
          : localStorage.getItem('GUIDeasyConf') !== null
            ? localStorage.getItem('GUIDeasyConf')
            : null;
        localStorage.setItem('GUIDeasyConf',this.GUID);
      } catch (error) {
        console.log(error);
        this.$palantir.trackAction(186,JSON.stringify(error));
      }
    },
    // calcScreenForFirst(){
    //   console.log('calcScreenForFirst')
    //   if (this.demandState.demandState !== 0 ) {
    //     console.log('demandState !== 0')
    //     return;
    //   }
    //
    //   if (this.demandState.allPhotosAttached === 0) {
    //     console.log('allPhotosAttached === 0')
    //     this.$store.dispatch('inst_initForm', 'documents');
    //     return;
    //   }
    //   if (this.demandState.easyAV === 0) {
    //     console.log('easyAV === 0')
    //     this.$store.dispatch('inst_initForm', 'anketa');
    //     return;
    //   }
    //   if (this.demandState.boxSelected === 0) {
    //     console.log('boxSelected === 0')
    //     this.$store.dispatch('inst_initForm', 'box');
    //     return;
    //   }
    //   if (this.demandState.iuConfirm === 0) {
    //     console.log('iuConfirm === 0')
    //     this.$store.dispatch('inst_initForm', 'iuConfirm');
    //     return;
    //   }
    //   if (this.demandState.easyAV === 1 && this.demandState.allPhotosAttached === 1 && this.demandState.boxSelected === 1 && this.demandState.iuConfirm === 1) {
    //     this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandEasy');
    //   }
    //
    // },
    async easyAVreadyToSave(){
      console.log('easyAVreadyToSave')
      const fieldsToSave = [
        'SOURCE_OF_INCOME',
        'WORK_JOB',
        'WORK_JOB_PHONE',
        'EXPER_RADIO',
        'WORK_TITLE',
        'AVERAGE_EXPENSES_PER_MONTH',
        'PURPOSE_OF_THE_LOAN',
        'CONTACT',
        'CONTACT_PHONE',
        'ASP',
        'AGREEMENT_KI_REQUEST'
      ];
      const fieldsToSaveVip = [
        'SOURCE_OF_INCOME',
        'AVERAGE_EXPENSES_PER_MONTH',
        'PURPOSE_OF_THE_LOAN',
        'CONTACT',
        'CONTACT_PHONE',
        'ASP',
        'AGREEMENT_KI_REQUEST'
      ]
      const selectFields =  this.valuesVuex.SOURCE_OF_INCOME === 'пенсия' ? fieldsToSaveVip : fieldsToSave;

      console.log({selectFields})
      let check = true;
      selectFields.forEach((item)=>{
        console.log(item)
        console.log(typeof this.valuesVuex[item] === 'string')
        console.log(this.valuesVuex.length)
        console.log(this.valuesVuex[item].length)
        if(typeof this.valuesVuex[item] === 'string' && this.valuesVuex[item].length === 0) {
          check = false
        }
      });
      console.log({check})
      if (check) {
       return  await this.$store.dispatch('instSaveFormAV');
        // await this.$store.dispatch('instGetDemandState');
      } else {
        return  false;
      }
    },
    getFormData(){
      this.$external.run({
        action: 'easyConfirm_get',
        jsonData:{
          GUID: this.GUID,
        }
      }).then((res) => {
        try {
          const formFormData = JSON.parse(res.ExecutionResult.formData);
          console.log('formFormData',formFormData)
        } catch (error){
          console.log(error);
        }

      }).catch((error) => {
        console.log(error);
      });
    }
  },
  components: {
    instForm: () => import('@/components/inst/instForm.vue'),
  },
  // watch: {
  //   'demandState.demandState'(newVal) {
  //     console.log('watch demandState.demandState')
  //     console.log(newVal)
  //     switch (newVal){
  //       case -1:
  //         this.$store.dispatch('inst_trySetSystemScreen', 'instRejectTime');
  //         break;
  //       case 1:
  //         this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandEasy');
  //         break;
  //       case 2:
  //         this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandDefault');
  //         break;
  //       case 0:
  //         this.calcScreenForFirst();
  //         break;
  //     }
  //   },
  //   'demandState.allPhotosAttached'(newVal){
  //     console.log('watch  demandState.allPhotosAttached')
  //     console.log(newVal)
  //     this.calcScreenForFirst();
  //   },
  //   'demandState.easyAV'(newVal){
  //     console.log('watch  demandState.easyAV')
  //     console.log(newVal)
  //     this.calcScreenForFirst();
  //   },
  //   'demandState.boxSelected'(newVal){
  //     console.log('watch  demandState.boxSelected')
  //     console.log(newVal)
  //     this.calcScreenForFirst();
  //   },
  //   'demandState.iuConfirm'(newVal){
  //     console.log('watch  demandState.iuConfirm')
  //     console.log(newVal)
  //     this.calcScreenForFirst();
  //   }
  // },
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
      currentStepForm: state => state.instForm.inst_CurrentStepForm,
      valuesVuex: state => state.Form.sendData
    }),
    issetGuid() {
      let s = "" + this.GUID;
      s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
      return s !== null;
    }
  },
  async mounted() {

    console.log('----------------------------------------')
    this.parseParam();
    this.$palantir.trackAction(181, `${localStorage.getItem('GUIDeasyConf')}`);
    if (this.issetGuid) {
      if (this.demandState.Amount === 0) {
        this.$store.dispatch('inst_trySetSystemScreen', 'instLoaderGetDemandState');
      }
    } else {
      await this.$store.dispatch('inst_trySetSystemScreen', 'instRejectTime');
    }
  }
}
</script>

<style>

</style>
